document.addEventListener("DOMContentLoaded", function() {
    const checkoutButton = document.querySelector("form[action='/checkout'] button[type='submit']");
    
    if (checkoutButton) {
        checkoutButton.addEventListener("click", function(event) {
            event.preventDefault(); // 一旦フォーム送信を止める

            let orderNote = document.getElementById('cart-note').value;

            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    note: orderNote // ここをシンプルにする
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log("カート note 更新:", data);
                // 更新完了後にフォームを送信
                checkoutButton.closest("form").submit();
            })
            .catch(error => console.error("カート note 更新失敗:", error));
        });
    }
});

